// src/components/signup/registration/RegistrationPhases/BarVerification.js
// *** FULLY UPDATED IMPLEMENTATION ***
// Includes all Phase 3 fields: Firm, Address, Bar ID, City, Zip, State, Years Exp, Practice Areas, Privacy, Optional Bio/Website

import React from 'react';
import { Lock, Briefcase, Calendar } from 'lucide-react'; // Added icons if needed for inputs

// --- Practice Area List (Define or Import) ---
// It's often better to define this in a separate constants file and import it
const PRACTICE_AREAS_OPTIONS = [
  'Personal Injury', 'Family Law', 'Criminal Defense', 'Real Estate',
  'Business Law', 'Immigration', 'Estate Planning', 'Employment Law',
  'Intellectual Property', 'Tax Law', 'Civil Litigation', 'Corporate Law', 'Other' // Added Other option
];
// --- End Practice Area List ---

export const BarVerification = ({ formData = {}, onChange, errors = {} }) => {

  // Keep zip change handler for formatting
  const handleZipChange = (e) => {
    const zip = e.target.value.replace(/\D/g, '').slice(0, 5);
    // Use the structure expected by the main handleChange in RegistrationForm
    // The parent's handleChange will handle updating the state.
    onChange({ target: { name: 'firmZip', value: zip } });
  };

  // Generic handler for practice areas checkboxes - just passes event up
  // The parent's handleChange should handle array logic based on name="practiceAreas"
  const handlePracticeAreaChange = (e) => {
      onChange(e);
  };

  return (
    <div className="w-full space-y-6"> {/* Increased spacing */}

      {/* Firm Name */}
      <div className="relative">
        <label className="absolute -top-2.5 left-4 px-2 bg-[#fef6ef] text-gray-500 text-sm">Firm Name</label>
        <input type="text" name="firmName" value={formData.firmName || ''} onChange={onChange} placeholder="Enter firm name" required
          className={`w-full px-4 py-3 bg-transparent border ${errors.firmName ? 'border-red-500' : 'border-gray-300'} rounded-full focus:outline-none focus:border-gray-400 placeholder-gray-400 text-gray-800`}
        />
        {errors.firmName && <p className="text-red-500 text-xs mt-1 ml-4">{errors.firmName}</p>}
      </div>

      {/* Firm Address */}
      <div className="relative">
        <label className="absolute -top-2.5 left-4 px-2 bg-[#fef6ef] text-gray-500 text-sm">Firm Street Address</label>
        <input type="text" name="office_address" value={formData.office_address || ''} onChange={onChange} placeholder="Enter street address" required
          className={`w-full px-4 py-3 bg-transparent border ${errors.office_address ? 'border-red-500' : 'border-gray-300'} rounded-full focus:outline-none focus:border-gray-400 placeholder-gray-400 text-gray-800`}
        />
        {errors.office_address && <p className="text-red-500 text-xs mt-1 ml-4">{errors.office_address}</p>}
      </div>

       {/* City, State, Zip Row */}
       <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
         <div className="relative">
           <label className="absolute -top-2.5 left-4 px-2 bg-[#fef6ef] text-gray-500 text-sm">City</label>
           <input type="text" name="firmCity" value={formData.firmCity || ''} onChange={onChange} placeholder="Enter city" required
             className={`w-full px-4 py-3 bg-transparent border ${errors.firmCity ? 'border-red-500' : 'border-gray-300'} rounded-full focus:outline-none focus:border-gray-400 placeholder-gray-400 text-gray-800`}
           />
           {errors.firmCity && <p className="text-red-500 text-xs mt-1 ml-4">{errors.firmCity}</p>}
         </div>
         <div className="relative">
            <label className="absolute -top-2.5 left-4 px-2 bg-[#fef6ef] text-gray-500 text-sm">State</label>
            <select name="firmState" value={formData.firmState || ''} onChange={onChange} required
              className={`w-full px-4 py-3 bg-transparent border ${errors.firmState ? 'border-red-500' : 'border-gray-300'} rounded-full focus:outline-none focus:border-gray-400 text-gray-600 appearance-none cursor-pointer`}
            >
              <option value="" disabled>Select State</option>
               <option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option>
            </select>
            {errors.firmState && <p className="text-red-500 text-xs mt-1 ml-4">{errors.firmState}</p>}
         </div>
         <div className="relative">
           <label className="absolute -top-2.5 left-4 px-2 bg-[#fef6ef] text-gray-500 text-sm">Zip Code</label>
           <input type="text" name="firmZip" value={formData.firmZip || ''} onChange={handleZipChange} placeholder="Enter zip" maxLength={5} required
             className={`w-full px-4 py-3 bg-transparent border ${errors.firmZip ? 'border-red-500' : 'border-gray-300'} rounded-full focus:outline-none focus:border-gray-400 placeholder-gray-400 text-gray-800`}
           />
           {errors.firmZip && <p className="text-red-500 text-xs mt-1 ml-4">{errors.firmZip}</p>}
         </div>
      </div>


      {/* Bar ID and Years of Experience Row */}
      <div className="grid grid-cols-2 gap-4">
         {/* Bar ID */}
         <div className="relative">
            <label className="absolute -top-2.5 left-4 px-2 bg-[#fef6ef] text-gray-500 text-sm">Bar ID</label>
            <input type="text" name="barId" value={formData.barId || ''} onChange={onChange} placeholder="Enter Bar ID" required
              className={`w-full px-4 py-3 bg-transparent border ${errors.barId ? 'border-red-500' : 'border-gray-300'} rounded-full focus:outline-none focus:border-gray-400 placeholder-gray-400 text-gray-800`}
            />
            {errors.barId && <p className="text-red-500 text-xs mt-1 ml-4">{errors.barId}</p>}
         </div>

         {/* Years of Experience Input */}
         <div className="relative">
            <label className="absolute -top-2.5 left-4 px-2 bg-[#fef6ef] text-gray-500 text-sm">Years of Experience</label>
            <input
              type="number"
              name="yearsOfExperience" // Matches the key in formData
              value={formData.yearsOfExperience || ''}
              onChange={onChange} // Use the handler from RegistrationForm
              placeholder="e.g., 5"
              min="0"
              required
              className={`w-full px-4 py-3 bg-transparent border ${errors.yearsOfExperience ? 'border-red-500' : 'border-gray-300'} rounded-full focus:outline-none focus:border-gray-400 placeholder-gray-400 text-gray-800`}
            />
            {errors.yearsOfExperience && <p className="text-red-500 text-xs mt-1 ml-4">{errors.yearsOfExperience}</p>}
         </div>
      </div>

      {/* Practice Areas Section */}
       <div className="relative pt-2"> {/* Added padding top */}
            <label className="block text-gray-500 text-sm mb-2">Practice Areas (Select all that apply)</label>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3"> {/* Increased gap */}
                {PRACTICE_AREAS_OPTIONS.map(area => (
                    <label key={area} className="flex items-center space-x-2 cursor-pointer group">
                       <input
                         type="checkbox"
                         name="practiceAreas" // Name matches formData key
                         value={area} // Value is the specific area string
                         // Check if this area is in the formData array
                         checked={formData.practiceAreas?.includes(area) || false}
                         onChange={onChange} // Use generic handler from parent
                         className="rounded border-gray-400 text-[#34261E] focus:ring-[#34261E] focus:ring-offset-0 h-4 w-4 cursor-pointer"
                       />
                       <span className="text-sm text-gray-800 group-hover:text-black">{area}</span>
                    </label>
                ))}
            </div>
           {errors.practiceAreas && <p className="text-red-500 text-xs mt-1 ml-4">{errors.practiceAreas}</p>}
       </div>


      {/* Privacy Setting */}
      <div className="relative">
        <label className="block text-gray-500 text-sm mb-2">Profile Visibility</label>
        <select name="publicReferrals"
           value={formData.publicReferrals ? 'public' : 'private'} // Reflect boolean state
           onChange={(e) => onChange({ target: { name: 'publicReferrals', value: e.target.value === 'public' }})} // Update boolean state
          className={`w-full px-4 py-3 bg-transparent border ${errors.publicReferrals ? 'border-red-500' : 'border-gray-300'} rounded-full focus:outline-none focus:border-gray-400 text-gray-600 appearance-none cursor-pointer pr-12`}
        >
          <option value="private">Private (Default - Only viewable by your network)</option>
          <option value="public">Public (Viewable in public directory - Coming Soon)</option>
        </select>
        <span className="absolute right-4 top-9 text-gray-400 pointer-events-none"> <Lock size={20} /> </span>
        {errors.publicReferrals && <p className="text-red-500 text-xs mt-1 ml-4">{errors.publicReferrals}</p>}
      </div>

       {/* Optional Bio and Website */}
        <div className="relative pt-2">
          <label className="absolute -top-0.5 left-4 px-2 bg-[#fef6ef] text-gray-500 text-sm">Bio (Optional)</label>
          <textarea name="bio" value={formData.bio || ''} onChange={onChange} placeholder="Share a brief description of your practice, experience, or focus..." rows={3}
            className={`w-full px-4 py-3 bg-transparent border border-gray-300 rounded-lg focus:outline-none focus:border-gray-400 placeholder-gray-400 text-gray-800`}
          />
       </div>
        <div className="relative">
          <label className="absolute -top-2.5 left-4 px-2 bg-[#fef6ef] text-gray-500 text-sm">Website (Optional)</label>
          <input type="url" name="website" value={formData.website || ''} onChange={onChange} placeholder="https://yourfirmwebsite.com"
            className={`w-full px-4 py-3 bg-transparent border border-gray-300 rounded-full focus:outline-none focus:border-gray-400 placeholder-gray-400 text-gray-800`}
          />
       </div>

    </div>
  );
};

export default BarVerification;